// extracted by mini-css-extract-plugin
export default {"indicatorFlag":"StatusIndicator_indicatorFlag__dOXRK","wrapper":"StatusIndicator_wrapper__tU4+o"};